import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import Rapid7InsightCredentialsForm from './Rapid7InsightCredentialsForm';
import Rapid7InsightMappingForm from './Rapid7InsightMappingForm';
import { columnRenderArrayData } from 'utils/tableUtils';

const Rapid7InsightConfligListing = (props) => {

    const extraColumns = [{
        dataIndex: "applicationName",
        title: "Project",
        width: 200,
    },
    {
        dataIndex: "scanConfigName",
        title: "Scan Config",
        render: (scanConfigName) => scanConfigName ? columnRenderArrayData(scanConfigName) : "All",
        width: 150,
    }];

    return (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={Rapid7InsightMappingForm}
        extraColumns={extraColumns}
        CredentialsForm={Rapid7InsightCredentialsForm}
        displayComponentName={"Project"}
     />
)};

export default Rapid7InsightConfligListing;
